import React from "react";

const Survey = ({ style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36" }) => (
    <svg
        width={size}
        height={size}
        style={style}
        viewBox={viewBox}
        fill="none"
        className={`${className || ""}`}
    >
        <path
            className="u_fill"
            d="M24.542 2H5.573A1.58 1.58 0 0 0 4 3.591V32.41c0 .427.169.827.462 1.12.294.302.694.471 1.111.471h25.298c.418 0 .818-.169 1.111-.462.294-.302.462-.702.462-1.13V10l-7.902-8Zm1.805 12.151-10 10.196-.125.133-.124-.133-6-6.116-.125-.124.125-.125 1.333-1.36.125-.133.124.133 4.542 4.631 8.542-8.71.125-.134.124.133 1.334 1.36.124.125-.124.124Z"
            fill={fill}
        />
    </svg>
);

export default Survey;


